module.exports = __webpack_public_path__ + "img/location-header_1200.c63cf7df.jpg";